import { DeviceAvailability, IDeviceAvailability, ItemState, ISuperBannerItem } from "..";
import { observable, action, computed } from "mobx";
import { IClientIncludeInManager } from "../..";

export type SuperBannerJackpotItemType = {
    AllowDevices: DeviceAvailability;
    JackpotId: number;
    Id: number;
    SportId: number;
    HashClientIncludeIn:string;
}

export class SuperBannerJackpotItem implements IDeviceAvailability, ISuperBannerItem {
    AllowDevices!: DeviceAvailability;
    Id: number;
    @observable state: ItemState;
    SportId: number;
    cmsConfig: any;
    ClientHashClass: string;
    ClientHashAttribute: string;

    constructor(source: SuperBannerJackpotItemType,clientIncludeInManager:IClientIncludeInManager) {
        this.Id = source.Id;
        this.AllowDevices = source.AllowDevices;
        this.state = ItemState.loading;
        this.SportId = source.SportId;
        this.ClientHashClass = clientIncludeInManager.getElementClass(source.HashClientIncludeIn);
        this.ClientHashAttribute = source.HashClientIncludeIn;
        this.cmsConfig = source; // we will pass later whole item to the JP component
    }

    @action.bound setState(state: ItemState): void {
        // just keep empty it for backward compatibility
    }
    @computed get IsLoading(): boolean {
        return this.state === ItemState.loading;
    }

    @action.bound toggleAvailableState(isOn: boolean): void {
        this.state = isOn ? ItemState.available : ItemState.unavailable;
    }
}